import { getCocoplusRecommendTrackingParams } from "~/lib/cocoplusRecommendExperiment";
import {
  FIREBASE_EVENT_NAME,
  type FirebaseEventParamsMap,
  trackFirebaseEvent,
} from "~/lib/tracking/firebase";
import { useAuthStore } from "~/stores/useAuthStore";

/**
 * demo_call_banner_step を送る。coco+ では「おすすめ枠」A/B の群（ab_variant）と
 * 入口の見た目（placement）を必ず付ける。他のアプリは従来どおり step のみ。
 */
export const trackDemoCallBannerStep = (
  step: FirebaseEventParamsMap["demo_call_banner_step"]["step"],
): void => {
  trackFirebaseEvent(FIREBASE_EVENT_NAME.DEMO_CALL_BANNER_STEP, {
    step,
    ...getCocoplusRecommendTrackingParams(useAuthStore.getState().userId),
  });
};
